import { 
  UPDATE_PREVIEW_LOADING, 
  UPDATE_PREVIEW_FILE,
  UPDATE_PREVIEW_SHOW
} from './constants'

const updatePreviewLoading = (loading) => ({type: UPDATE_PREVIEW_LOADING, loading})
const updatePreviewShow = (show) => ({type: UPDATE_PREVIEW_SHOW, show})
const updatePreviewFile = (link, name, id) => ({type: UPDATE_PREVIEW_FILE, link, name, id})

export {
  updatePreviewLoading,
  updatePreviewFile,
  updatePreviewShow
}